"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _Module = _interopRequireDefault(require("../Icons/Module"));
var Styled = _interopRequireWildcard(require("./styles"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ModuleIcon = ({
  icon
}) => {
  const theme = (0, _styledComponents.useTheme)();
  return _react.default.createElement(Styled.ModuleIcon, null, icon ? _react.default.createElement(Styled.ModuleIconInner, {
    icon: icon
  }) : _react.default.createElement(_Module.default, {
    fill: theme.colors.appFrame.header.moduleIconColor
  }));
};
var _default = exports.default = ModuleIcon;